/**
 * Which Initial Response experience an incident shows: the original tab stepper, or the forms view built around the
 * editable ICS-201.
 *
 * Persisted per incident the way the Planning P dashboard persists its own URL, so a choice survives a reload, and
 * carried in the URL so a link can pin one. Mirrors `iapFormsView`.
 */

export type InitialResponseView = 'legacy' | 'new';

export const INITIAL_RESPONSE_VIEW_PARAM = 'irView';

/**
 * New is what an incident gets unless someone has said otherwise, because the ICS-201 is the form initial response is
 * actually run from.
 */
export const DEFAULT_INITIAL_RESPONSE_VIEW: InitialResponseView = 'new';

export const initialResponseViewStorageKey = (incidentId: string): string =>
  `initial-response-view-${incidentId}`;

export function parseInitialResponseView(
  raw: string | null | undefined
): InitialResponseView | undefined {
  return raw === 'legacy' || raw === 'new' ? raw : undefined;
}

export function serializeInitialResponseView(view: InitialResponseView): string {
  return view;
}

/**
 * The view to show, in precedence order: the URL pins it, then a remembered explicit choice, then the default.
 *
 * A remembered choice has to beat the default, or switching to Legacy would not survive the next visit and the toggle
 * would appear not to work.
 */
export function resolveInitialResponseView(args: {
  paramValue: string | null | undefined;
  storedValue: string | null | undefined;
}): InitialResponseView {
  return (
    parseInitialResponseView(args.paramValue) ??
    parseInitialResponseView(args.storedValue) ??
    DEFAULT_INITIAL_RESPONSE_VIEW
  );
}
